import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import * as ECharts from 'echarts'

const app=createApp(App);
app.use(router).mount('#app');
app.config.globalProperties.$ECharts = ECharts;
